export enum VEHICLE_DEFAULT_FIELDS {
  VEHICLE_TYPE = 'VEHICLE_TYPE',
}

export enum COVER_NOTES_STATE {
  ISSUED = 'ISSUED',
  EXPIRED = 'EXPIRED',
  CLOSED = 'CLOSED',
  VERIFIED = 'VERIFIED',
  REQUESTED = 'REQUESTED',
  CANCELLED = 'CANCELLED',
}
